import { render, staticRenderFns } from "./Casa.vue?vue&type=template&id=c0ca2446"
import script from "./Casa.vue?vue&type=script&lang=js"
export * from "./Casa.vue?vue&type=script&lang=js"
import style0 from "./Casa.vue?vue&type=style&index=0&id=c0ca2446&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports